/**
 * mulberry32 — a small, fast, deterministic PRNG (public-domain algorithm).
 * Pure: no `Math.random`, no `Date.now`, no other external entropy. The same
 * integer seed always produces the exact same sequence of values in [0, 1),
 * which is what lets ear-training questions be reproducible from a seed.
 */
export function makeRng(seed) {
    let state = seed >>> 0;
    return function rng() {
        state = (state + 0x6d2b79f5) | 0;
        let t = Math.imul(state ^ (state >>> 15), 1 | state);
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}
//# sourceMappingURL=rng.js.map